<template>
  <div class="card flex-row flex-wrap">
    <div class="card-header border-0">
      <img src="/static/images/ic-snackbar-sam.png" class="icon" alt="publisher-profile">
    </div>
    <div class="card-block px-2">
      <div class="card-title" v-html="$t('prime.recommend_notice.description')" />
      <div class="card-actions">
        <button class="btn cl-btn" type="button" @click="$emit('closeSnackBar')">{{ $t('prime.recommend_notice.cancel') }}</button>
        <button class="btn cl-btn close-btn" type="button" @click="$emit('okSnackBar')">{{ $t('prime.recommend_notice.confirm') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'prime-snackbar',
  };
</script>

<style lang="scss" scoped>
  .card {
    border: none;
    box-shadow: 1px -4px 6px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    position: fixed;
    right: 14px;
    bottom: 14px;
    height: 140px;
    width: 360px;
    padding: 8px;

    .card-header {
      background-color: #ffffff;
      width: 20%;
      padding: 14px;
      position: relative;

      .icon {
        width: 48px;
        height: 48px;
        object-fit: cover;
      }

    }

    .card-block {
      font-size: 14px;
      padding: 14px;
      width: 80%;
      position: relative;

      .card-title {
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-inline-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        max-height: 40px;
        word-break: break-all;
        white-space: normal;
      }

      .card-text {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.38);
        padding: 0 0 4px 0; 
      }

      .card-actions {
        position: absolute;
        right: 14px;
        bottom: 8px;
        
        button {
          margin: 4px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// PrimeSnackBar.vue?2e0049e5